import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const EndowmentPlans = () => {
  return (
    <>
      <TopBanner content={"Endowment Plans"} />
      <ContentWrapper>
        <div className="text-content">
          <p></p>
          <h3>Protect Today. Prosper Tomorrow.</h3>
          <p>
            An Endowment Plan is a smart combo of insurance + savings. It not
            only protects your family financially in case of your unfortunate
            demise but also helps you build a guaranteed savings corpus if you
            survive the policy term.
          </p>
          <h3>Why Choose an Endowment Plan?</h3>
          <ul>
            <li>Dual Benefit: Life cover + long-term savings</li>
            <li>Guaranteed Returns: Safer than market-linked investments</li>
            <li>Tax Savings: Enjoy benefits under Section 80C & 10(10D)</li>
            <li>Flexible Payments: Pay monthly, quarterly, or yearly</li>
            <li>Custom Coverage: Add riders for enhanced protection</li>
          </ul>
          <h3>Types of Endowment Plans:</h3>
          <ul>
            <li>Unit-Linked Endowment – Combines investment and insurance</li>
            <li>Low-Cost Endowment – Great for goal-based savings</li>
            <li>
              Non-Profit Endowment – Focuses on guaranteed maturity benefits
            </li>
          </ul>
          <h3>Optional Riders You Can Add:</h3>
          <ul>
            <li>Critical Illness Cover </li>
            <li>Accidental Death Benefit </li>
            <li>Accidental death cover</li>
            <li>Permanent Disability Cover</li>
            <li>Waiver of Premium on Disability or Illness</li>
          </ul>

          <p>
            <strong>
              Endowment plans are ideal if you want peace of mind + a savings
              goal, all in one.
            </strong>
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default EndowmentPlans;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
